import siteMessage from "@insite/client-framework/SiteMessage";
import Typography from "@insite/mobius/Typography";
import Group from "@midland-industries/Components/Group";
import { colors } from "@midland-industries/Styles/colors";
import React, { useEffect, useState } from "react";

interface MessageBannerProps {
    message: string;
}

const MessageBanner: React.FC<MessageBannerProps> = ({ message }) => {
    const [showBanner, setShowBanner] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setShowBanner(false);
        }, 10000);
    }, []);

    return showBanner ? (
        <Group align="center" justify="center" style={{ width: "100%", padding: "6px 0", background: colors.warning }}>
            <Typography size={15} lineHeight="24px" color={colors.textMain}>
                {siteMessage(message)}
            </Typography>
        </Group>
    ) : (
        <></>
    );
};

export default MessageBanner;
